import type { RolePermissionCategory, RolePermissionItem } from '../types/role';

/**
 * Permission keys and labels for customer roles.
 * Keys must match OpenAPI PermissionKey enum; categories: Order, Customers.
 */
export const ROLE_PERMISSION_CATEGORIES = ['order', 'customers'] as const;
export const ROLE_PERMISSIONS_CATALOG: RolePermissionItem[] = [
  {
    key: 'purchase-edit-quoted-prices',
    label: 'Edit quoted prices',
    description: 'Change the price of items that have been quoted to a customer.',
    category: 'order',
  },
  {
    key: 'purchase-edit-custom-items',
    label: 'Edit custom items',
    description: 'Add or modify custom line items on an order.',
    category: 'order',
  },
  {
    key: 'purchase-edit-custom-shipping',
    label: 'Edit custom shipping',
    description: 'Override the shipping method or cost on an order.',
    category: 'order',
  },
  {
    key: 'purchase-override-product-settings',
    label: 'Override product settings',
    description: 'Bypass product-level rules like minimum order quantities or increments.',
    category: 'order',
  },
  {
    key: 'cart-complete',
    label: 'Complete Checkout',
    description: 'Place orders via the normal checkout process.',
    category: 'order',
  },
  {
    key: 'quote-create',
    label: 'Create Quotes',
    description: 'Create quotes via the checkout.',
    category: 'order',
  },
  {
    key: 'quote-edit',
    label: 'Edit Quotes',
    description: 'Edit quotes once created.',
    category: 'order',
  },
  {
    key: 'quote-complete',
    label: 'Complete Quotes',
    description: 'Finalise quotes once approved.',
    category: 'order',
  },
  {
    key: 'quote-archive',
    label: 'Archive Quotes',
    description: 'Archive quotes when no longer required.',
    category: 'order',
  },
  {
    key: 'quote-assignee-edit',
    label: 'Edit Quote Assignee',
    description: 'Manage the sales agent assigned to quotes.',
    category: 'order',
  },
  {
    key: 'customers-create-new',
    label: 'Create new customers',
    description: 'Add new customer records to the platform.',
    category: 'customers',
  },
  {
    key: 'addresses-edit',
    label: 'Edit addresses',
    description: "Update shipping and billing addresses on a customer's account.",
    category: 'customers',
  },
  {
    key: 'addresses-edit-default',
    label: 'Edit address defaults',
    description: 'Change which address is set as the default for shipping or billing.',
    category: 'customers',
  },
];

export const ROLE_PERMISSION_CATEGORY_LABELS: Record<RolePermissionCategory, string> = {
  order: 'Orders',
  customers: 'Customers',
};
